import { css } from 'linaria';

export const colorPaletteContainer = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-150);
  padding: var(--space-150) 0;
`;

export const prohibitedIconContainer = css`
  width: var(--space-475);
  height: var(--space-475);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const transparentColorButton = css`
  border: var(--space-10) solid var(--control-secondary, hsla(42, 16%, 76%, 1));
  border-radius: 50%;
  margin: var(--space-25);
`;

export const transparentColorButtonActive = css`
  border: var(--space-25) solid var(--control-primary, hsla(42, 16%, 76%, 1));
  margin: var(--space-10);
`;

export const addColorButton = css`
  margin: var(--space-25);
`;
